import React from 'react';
import NotificationStackListener from './NotificationStackListener';
import { playMemberNotificationSound, MEMBER_SOUND_PREF } from '../utils/notificationSounds';

export default function MemberNotificationListener() {
  return (
    <NotificationStackListener
      tokenKey="memberToken"
      sinceKey="member_notif_since"
      soundPrefKey={MEMBER_SOUND_PREF}
      apiPath="/member-portal/notifications"
      playSound={playMemberNotificationSound}
      severity="success"
      soundPromptTitle="Member portal sounds"
      soundPromptBody="Play a softer chime for announcements, events, elections, and other updates? You can choose “Not now” to browse quietly."
    />
  );
}
